import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import HeaderDashboard from "../Components/HeaderDashboard";
import { GetApprovalDetails } from "../Services/ApprovalAPI";
import { AcceptApprovalRequest } from "../Services/ApprovalAPI";
import { RejectApprovalRequest } from "../Services/ApprovalAPI";
import HotelApprovalDetail from "../Dashboard/HotelApprovalDetail";

const ApprovalDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const referenceNo = queryParams.get("referenceNo");
  const productType = queryParams.get("productType");

  const [approvalDetails, setApprovalDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [remark, setRemark] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);

  const hasCalled = useRef(false);

  useEffect(() => {
    if (referenceNo) {
      if (hasCalled.current) return;
      hasCalled.current = true;
      fetchApprovalDetails(referenceNo);
    } else {
      console.warn("Missing referenceNo and trackId");
    }
  }, [referenceNo]);

  //   const fetchApprovalDetails = async (referenceNo) => {
  //     try {
  //       setLoading(true);
  //       setError("");
  //       const response = await GetApprovalDetails(referenceNo);
  //       setApprovalDetails(response.approvalDetails);
  //       console.log("setApprovalDetails", response.approvalDetails);
  //     } catch (err) {
  //       setError(
  //         "Failed to load flight Requested Approval details. Please try again.",
  //       );
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  const fetchApprovalDetails = async (referenceNo) => {
    try {
      setLoading(true);
      setError("");
      const response = await GetApprovalDetails(referenceNo, productType);
      setApprovalDetails(response.approvalDetails);
      console.log("setApprovalDetails", response.approvalDetails);
    } catch (err) {
      setError(
        "Failed to load flight Requested Approval details. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  const SubmitAcceptApprovalRequest = async (item) => {
    if (!item) {
      alert("Invalid approval data");
      return;
    }
    const { referenceNo, level1Approver, level1ApproverEmail, userId } = item;
    if (!referenceNo || !level1ApproverEmail) {
      alert("Missing required data");
      return;
    }
    setLoading(true);
    try {
      const requestBody = {
        referenceNo: referenceNo,
        level1ApproverEmal: level1ApproverEmail,
        level1Approver,
        product: "Flight",
        UserId: userId,
      };
      console.log("requestBody:", requestBody);
      const data = await AcceptApprovalRequest(requestBody);

      console.log("AcceptApprovalRequest:", data);
      navigate(`/thankyou?ReferenceNo=${referenceNo}`);
      // const list = data?.allApprovals || [];
      // setApprovals(list);
    } catch (error) {
      console.error("Error fetching data:", error);
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  const SubmitRejectApprovalRequest = async (item) => {
    if (!item) {
      alert("Invalid approval data");
      return;
    }
    const { referenceNo, level1Approver, level1ApproverEmail, userId } = item;
    if (!referenceNo || !level1ApproverEmail) {
      alert("Missing required data");
      return;
    }

    const modalElement = document.getElementById("myModal");
    const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
    modalInstance.hide();
    setLoading(true);
    try {
      const requestBody = {
        referenceNo: referenceNo,
        level1ApproverEmal: level1ApproverEmail,
        level1Approver,
        product: "Flight",
        UserId: userId,
        remark: remark,
      };
      console.log("requestBody:", requestBody);
      const data = await RejectApprovalRequest(requestBody);
      alert(data.message);
      window.location.reload();
      setRemark("");
      setSelectedItem(null);
    } catch (error) {
      console.error("Error fetching data:", error);
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && (
        <p class="text-center load">
          <span class="loader"></span>
        </p>
      )}
      <HeaderDashboard></HeaderDashboard>
      <div className="toolbar py-2" id="kt_toolbar">
        <div
          id="kt_toolbar_container"
          className="container-fluid d-flex align-items-center"
        >
          <div className="flex-grow-1 flex-shrink-0 me-5">
            <div
              data-kt-swapper="true"
              data-kt-swapper-mode="prepend"
              data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
              className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0"
            >
              <h1 className="d-flex align-items-center text-gray-900 fw-bold my-1 fs-3">
                Dashboard
              </h1>
              <span className="h-20px border-gray-200 border-start mx-3"></span>
              <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                <li className="breadcrumb-item">
                  <a href="/approval" className="text-muted text-hover-primary">
                    Approval
                  </a>
                </li>
                <li class="breadcrumb-item">
                  <span class="bullet bg-gray-200 w-5px h-2px"></span>
                </li>
                <li class="breadcrumb-item text-gray-900">Approval Detail</li>
              </ul>
            </div>
          </div>
          <div class="d-flex align-items-center flex-wrap">
            <div class="d-flex align-items-center me-n2 me-lg-0">
              <a class="btn btn-sm btn-primary me-3" href="/approval">
                <i class="ki-outline ki-left fs-2"></i> Back To Approvals
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* {approvalDetails && approvalDetails.airBookingResponse.length > 0 ? (
                <>
                    <section className='wraper'>
                        <div className='box_shadow mt-16'>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <h4 className='headings'>Reason For Travel</h4>
                                </div>
                                <div className='col-md-6'>
                                    <div class="d-flex mb-3">
                                        <div class="labl">Trip ID </div>
                                        <div class="labl_detls">{approvalDetails.requestedApprovals[0].referenceNo}</div>
                                    </div>
                                </div>

                                <div className='col-md-6'>
                                    <div class="d-flex mb-3">
                                        <div class="labl">Travel Mode </div>
                                        <div class="labl_detls">Business Travel</div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div class="d-flex mb-3">
                                        <div class="labl">Employee ID </div>
                                        <div class="labl_detls">{approvalDetails.requestedApprovals[0].employeeId}</div>
                                    </div>
                                </div>

                                <div className='col-md-6'>
                                    <div class="d-flex mb-3">
                                        <div class="labl">Employee Name </div>
                                        <div class="labl_detls">{approvalDetails.requestedApprovals[0].travellerName}</div>
                                    </div>
                                </div>

                                <div className='col-md-6'>
                                    <div class="d-flex mb-3">
                                        <div class="labl">Biling Entity </div>
                                        <div class="labl_detls">{approvalDetails?.corporateDetails?.companyName}</div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div class="d-flex mb-3">
                                        <div class="labl">Selection Option</div>
                                        <div class="labl_detls">{approvalDetails?.selectedOption}</div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <h4 className='headings'>Travel Info</h4>
                                </div>

                                {(() => {
                                    const flightDetails = approvalDetails?.airBookingResponse?.[0]?.flightDetails || [];

                                    const firstSegment = flightDetails[0];
                                    const lastSegment = flightDetails[flightDetails.length - 1];
                                    // const stops = segments.length > 0 ? segments.length - 1 : 0;
                                    return (
                                        <>
                                            <div className='col-md-6'>
                                                <div class="d-flex mb-3">
                                                    <div class="labl">From City </div>
                                                    <div class="labl_detls">{firstSegment?.departAirportName} ({firstSegment?.departAirportCode})</div>
                                                </div>
                                            </div>

                                            <div className='col-md-6'>
                                                <div class="d-flex mb-3">
                                                    <div class="labl">To City </div>
                                                    <div class="labl_detls">{lastSegment?.arrivalAirportName} ({lastSegment?.arrivalAirportCode})</div>
                                                </div>
                                            </div>
                                        </>
                                    );
                                })()}
                                <div className='col-md-6'>
                                    <div class="d-flex mb-3">
                                        <div class="labl">Date Of Travel </div>
                                        <div class="labl_detls">{
                                            new Date(
                                                approvalDetails.airBookingResponse[0].flightDetails[0].departDateTime
                                            ).toLocaleDateString("en-GB", {
                                                day: "2-digit",
                                                month: "short",
                                                year: "numeric"
                                            })
                                        }</div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div class="d-flex mb-3">
                                        <div class="labl">Total Fare </div>
                                        <div class="labl_detls text-danger"><i className='fa fa-inr'></i> {(approvalDetails?.airBookingResponse?.[0]?.fareDetails?.totalFare || 0) + (approvalDetails?.airBookingResponse?.[1]?.fareDetails?.totalFare || 0)}</div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    {/* if (flightDetails.some(f => f.flightNumber === 2)) {
} *
                                    {approvalDetails?.recommendedOnwardFlight?.trip === 2 && approvalDetails?.recommendedOnwardFlight?.tripType === 2 ?
                                        (() => {
                                            const item = approvalDetails?.airBookingResponse?.[0];
                                            const onwardSegments = item.flightDetails?.filter(x => x.flightCount === 1) || [];
                                            const returnSegments = item.segments?.filter(x => x.flightCount === 2) || [];

                                            const onwardFirst = onwardSegments[0];
                                            const onwardLast = onwardSegments[onwardSegments.length - 1];

                                            const returnFirst = returnSegments[0];
                                            const returnLast = returnSegments[returnSegments.length - 1];

                                            return (
                                                <div className="result_repeat mb-3" key={0}>
                                                    <div className="row">
                                                        {/* ---------- LEFT SIDE (FLIGHT DETAILS) ---------- *
                                                        <div className="col-md-9">
                                                            {/* ----- ONWARD ----- *
                                                            <div className="row oneWay_flight_1">
                                                                <p className="mode_trvel">
                                                                    <span>
                                                                        <i className="fa fa-plane"></i> Departure
                                                                    </span>
                                                                </p>

                                                                <div className="col-md-4 col-lg-4">
                                                                    <div className="row">
                                                                        <div className="col-md-4">
                                                                            <img
                                                                                src={`/assets/images/Flight_Images/${onwardFirst?.airLineCode}.gif`}
                                                                                width="30"
                                                                                alt=""
                                                                            />
                                                                        </div>
                                                                        <div className="col-md-8">
                                                                            <span>
                                                                                {onwardSegments?.map((seg, i) => (
                                                                                    <span key={i}>
                                                                                        {seg.airLineCode}-{seg.flightNumber}
                                                                                        {i < onwardSegments.length - 1 && "/"}
                                                                                    </span>
                                                                                ))}
                                                                            </span>
                                                                            <div>{onwardFirst.airLineName}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-8 border-left-right">
                                                                    <div className="row">
                                                                        <div className="col-md-4">
                                                                            <div className="timer">
                                                                                <h4>{onwardFirst.departDateTime?.slice(11, 16)}</h4>
                                                                                <p>{onwardFirst.departAirportCode}</p>
                                                                            </div>
                                                                        </div>

                                                                        <div className="col-md-3">
                                                                            <div className="deruation">
                                                                                <p>{item.totalDuration}</p>

                                                                                <div className="bordr_top">
                                                                                    <i className="fa fa-plane"></i>
                                                                                </div>
                                                                                <p className="stops">
                                                                                    {onwardSegments.length - 1}{" "}
                                                                                    {(onwardSegments.length - 1) === 1 ? "stop" : "stops"}
                                                                                </p>
                                                                            </div>
                                                                        </div>

                                                                        <div className="col-md-4 offset-1">
                                                                            <div className="timer">
                                                                                <h4>{onwardLast.arrivalDateTime?.slice(11, 16)}</h4>
                                                                                <p>{onwardLast.arrivalAirportCode}</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* ----- RETURN ----- *
                                                            <div className="row oneWay_flight_2">
                                                                <p className="mode_trvel">
                                                                    <span>
                                                                        <i className="fa fa-plane"></i> Return
                                                                    </span>
                                                                </p>

                                                                <div className="col-md-4">
                                                                    <div className="row">
                                                                        <div className="col-md-4">
                                                                            <img
                                                                                src={`/assets/images/Flight_Images/${returnFirst?.airLineCode}.gif`}
                                                                                width="30"
                                                                                alt=""
                                                                            />
                                                                        </div>
                                                                        <div className="col-md-8">
                                                                            <span>
                                                                                {returnSegments?.map((seg, i) => (
                                                                                    <span key={i}>
                                                                                        {seg.airLineCode}-{seg.flightNumber}
                                                                                        {i < returnSegments.length - 1 && "/"}
                                                                                    </span>
                                                                                ))}
                                                                            </span>
                                                                            <div>{returnFirst.airLineName}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-8 border-left-right">
                                                                    <div className="row">
                                                                        <div className="col-md-4">
                                                                            <div className="timer">
                                                                                <h4>{returnFirst?.departDateTime?.slice(11, 16)}</h4>
                                                                                <p>{returnFirst?.departAirportCode}</p>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-3">
                                                                            <div className="deruation">
                                                                                <p>{item.totalDurationReturn}</p>
                                                                                <div className="bordr_top">
                                                                                    <i className="fa fa-plane"></i>
                                                                                </div>
                                                                                <p className="stops">
                                                                                    {returnSegments.length - 1}{" "}
                                                                                    {(returnSegments.length - 1) === 1 ? "stop" : "stops"}
                                                                                </p>
                                                                            </div>
                                                                        </div>

                                                                        <div className="col-md-4 offset-1">
                                                                            <div className="timer">
                                                                                <h4>{returnLast.arrivalDateTime?.slice(11, 16)}</h4>
                                                                                <p>{returnLast.arrivalAirportCode}</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="price_int">
                                                                <p className="type_frs">
                                                                    {
                                                                        item?.fares?.[0]?.fareType ??
                                                                        "Standard Fare"
                                                                    }
                                                                </p>
                                                                <div className="cos_int_flight">
                                                                    <i className="fa fa-inr"></i>{" "}
                                                                    {/* {formatINR(item?.fares?.[0]?.totalFare)} *
                                                                    {(item?.fares?.[0]?.totalFare)}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })
                                         :
                                        (approvalDetails?.airBookingResponse?.map((booking, i) => {
                                        const flight = booking?.flightDetails?.[0];

                                        if (!flight) return null;

                                        const flightDetails = booking?.flightDetails || [];
                                        const firstSegment = flightDetails[0];
                                        const lastSegment = flightDetails[flightDetails.length - 1];
                                        const stop = flightDetails.length - 1
                                        const flightNumber = flightDetails
                                            .map((seg) => `${seg.airLineCode}-${seg.flightNumber}`)
                                            .join(" / ");

                                        const departure = new Date(firstSegment.departDateTime);
                                        const arrival = new Date(lastSegment.arrivalDateTime);

                                        const depTime = `${departure.getHours().toString().padStart(2, "0")}:${departure
                                            .getMinutes()
                                            .toString()
                                            .padStart(2, "0")}`;

                                        const arrTime = `${arrival.getHours().toString().padStart(2, "0")}:${arrival
                                            .getMinutes()
                                            .toString()
                                            .padStart(2, "0")}`;

                                        const diffMs = arrival - departure;
                                        const hours = Math.floor(diffMs / (1000 * 60 * 60));
                                        const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

                                        const duration = `${hours.toString().padStart(2, "0")}:${minutes
                                            .toString()
                                            .padStart(2, "0")}`;

                                        return (
                                            <div className="result_repeat mt-3 mb-3" key={i}>
                                                <div className="row">
                                                    <div className="col-md-8 col-lg-8">
                                                        <div className="row">
                                                            <div className="col-md-4 col-lg-4">
                                                                <div className="row">
                                                                    <div className="col-md-4">
                                                                        <div className="flight_img">
                                                                            <img
                                                                                alt={flight.airLineName}
                                                                                width="50"
                                                                                src={`/assets/images/Flight_Images/${booking.validatingCarrier}.gif`}
                                                                                onError={(e) => (e.target.src = "/assets/images/Flight_Images/default.gif")}
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-8">
                                                                        <figure className="flight_sect">
                                                                            <span>
                                                                                {flightNumber}
                                                                            </span>
                                                                            <span className="airlineImage">
                                                                                {flight.airLineName}
                                                                            </span>
                                                                        </figure>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-8 col-lg-8 border-left-right">
                                                                <div className="row">
                                                                    <div className="col-md-4">
                                                                        <div className="timer">
                                                                            <h4>{depTime}</h4>
                                                                            <p>{firstSegment.departAirportCode}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <div className="deruation">
                                                                            <p>{duration}</p>
                                                                            <div className="bordr_top">
                                                                                <i className="fa fa-plane"></i>
                                                                            </div>
                                                                            <p className="stops">
                                                                                {stop === 0
                                                                                    ? "Non-stop"
                                                                                    : `${stop} Stop`}
                                                                            </p>
                                                                        </div>
                                                                    </div>

                                                                    {/* Arrival *
                                                                    <div className="col-md-4 offset-1">
                                                                        <div className="timer">
                                                                            <h4>{arrTime}</h4>
                                                                            <p>{lastSegment.arrivalAirportCode}</p>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>

                                                    {/* RIGHT - PRICE *
                                                    <div className="col-md-4 col-lg-4">
                                                        <div className="price_view">
                                                            <div className="flight_char color">
                                                                <i className="fa fa-inr"></i>
                                                                {booking?.fareDetails?.totalFare || 0}
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        );
                                    }))()}
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-12 mt-5'>
                                    <h4 className="headings">
                                        AI Recommended |{" "}
                                        <span style={{ color: "green" }}>
                                            Save <i className="fa fa-inr"></i>{" "}
                                            {(
                                                ((approvalDetails?.airBookingResponse?.[0]?.fareDetails?.totalFare || 0) + (approvalDetails?.airBookingResponse?.[1]?.fareDetails?.totalFare || 0)) -
                                                ((approvalDetails?.recommendedOnwardFlight?.fares?.[0]?.totalFare || 0) + (approvalDetails?.recommendedReturnFlight?.fares?.[0]?.totalFare || 0))
                                            )}
                                        </span>
                                    </h4>
                                </div>
                                <div className='recomndRare'>
                                    {(() => {
                                        const flight = approvalDetails?.recommendedOnwardFlight;
                                        const segments = flight?.segments || [];
                                        if (!segments.length) return null;

                                        const firstSegment = segments[0];
                                        const lastSegment = segments[segments.length - 1];
                                        const stop = segments.length - 1;

                                        const flightNumber = segments
                                            .map((seg) => `${seg.airLineCode}-${seg.flightNumber}`)
                                            .join(" / ");

                                        const departure = new Date(firstSegment.departDateTime);
                                        const arrival = new Date(lastSegment.arrivalDateTime);

                                        const depTime = `${departure.getHours().toString().padStart(2, "0")}:${departure
                                            .getMinutes()
                                            .toString()
                                            .padStart(2, "0")}`;

                                        const arrTime = `${arrival.getHours().toString().padStart(2, "0")}:${arrival
                                            .getMinutes()
                                            .toString()
                                            .padStart(2, "0")}`;

                                        const diffMs = arrival - departure;
                                        const hours = Math.floor(diffMs / (1000 * 60 * 60));
                                        const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

                                        const duration = `${hours.toString().padStart(2, "0")}:${minutes
                                            .toString()
                                            .padStart(2, "0")}`;

                                        return (
                                            <div className="result_repeat AI-Recomnd mb-3">
                                                <div className="row">
                                                    <div className="col-md-8 col-lg-8">
                                                        <div className="row">
                                                            <div className="col-md-4 col-lg-4">
                                                                <div className="row">
                                                                    <div className="col-md-4 col-lg-4">
                                                                        <div className="flight_img">
                                                                            <img
                                                                                alt="flight"
                                                                                width="50"
                                                                                src={`/assets/images/Flight_Images/${flight?.validatingCarrier}.gif`}
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-8 col-lg-8">
                                                                        <figure className="flight_sect">
                                                                            <span>{flightNumber}</span>
                                                                            <span className="airlineImage">
                                                                                {firstSegment.airLineName}
                                                                            </span>
                                                                        </figure>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-8 col-lg-8 border-left-right">
                                                                <div className="row">

                                                                    <div className="col-md-4 col-lg-4">
                                                                        <div className="timer">
                                                                            <h4>{depTime}</h4>
                                                                            <p>{firstSegment.departAirportCode}</p>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-3 col-lg-3">
                                                                        <div className="deruation">
                                                                            <p>{duration}</p>
                                                                            <div className="bordr_top">
                                                                                <i className="fa fa-plane"></i>
                                                                            </div>
                                                                            <p className="stops">{stop} stop</p>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-4 col-lg-4 offset-1">
                                                                        <div className="timer">
                                                                            <h4>{arrTime}</h4>
                                                                            <p>{lastSegment.arrivalAirportCode}</p>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 col-lg-4">
                                                        <div className="price_view">
                                                            <div className="flight_char">
                                                                <i className="fa fa-inr"></i>
                                                                {flight?.fares?.[0].totalFare}
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        );
                                    })()}
                                </div>
                                {approvalDetails.recommendedReturnFlight && (
                                    <div className='recomndRare'>
                                        {(() => {
                                            const flight = approvalDetails?.recommendedReturnFlight;

                                            if (!flight) return null;

                                            const segments = flight?.segments || [];

                                            // ✅ IMPORTANT SAFETY
                                            if (!segments.length) return null;

                                            const firstSegment = segments[0];
                                            const lastSegment = segments[segments.length - 1];

                                            const stopsCount = segments.length - 1;

                                            const stopsText =
                                                stopsCount === 0
                                                    ? "Non-stop"
                                                    : stopsCount === 1
                                                        ? "1 Stop"
                                                        : `${stopsCount} Stops`;

                                            const flightNumber = segments
                                                .map((seg) => `${seg.airLineCode}-${seg.flightNumber}`)
                                                .join(" / ");

                                            const formatTime = (date) => {
                                                const d = new Date(date);
                                                return `${d.getHours().toString().padStart(2, "0")}:${d
                                                    .getMinutes()
                                                    .toString()
                                                    .padStart(2, "0")}`;
                                            };

                                            return (
                                                <div className="result_repeat AI-Recomnd mb-3">
                                                    <div className="row">
                                                        <div className="col-md-8 col-lg-8">
                                                            <div className="row">
                                                                <div className="col-md-4 col-lg-4">
                                                                    <div className="row">
                                                                        <div className="col-md-4 col-lg-4">
                                                                            <div className="flight_img">
                                                                                <img
                                                                                    alt="flight"
                                                                                    width="50"
                                                                                    src={`/assets/images/Flight_Images/${flight?.validatingCarrier}.gif`}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-8 col-lg-8">
                                                                            <figure className="flight_sect">
                                                                                <span>{flightNumber}</span>
                                                                                <span className="airlineImage">
                                                                                    {firstSegment?.airLineName}
                                                                                </span>
                                                                            </figure>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-8 col-lg-8 border-left-right">
                                                                    <div className="row">
                                                                        <div className="col-md-4 col-lg-4">
                                                                            <div className="timer">
                                                                                <h4>{formatTime(firstSegment.departDateTime)}</h4>
                                                                                <p>{firstSegment.departAirportCode}</p>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-3 col-lg-3">
                                                                            <div className="deruation">
                                                                                <p>{flight?.totalDuration}</p>
                                                                                <div className="bordr_top">
                                                                                    <i className="fa fa-plane"></i>
                                                                                </div>
                                                                                <p className="stops">{stopsText}</p>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-4 col-lg-4 offset-1">
                                                                            <div className="timer">
                                                                                <h4>{formatTime(lastSegment.arrivalDateTime)}</h4>
                                                                                <p>{lastSegment.arrivalAirportCode}</p>
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 col-lg-4">
                                                            <div className="price_view">
                                                                <div className="flight_char">
                                                                    <i className="fa fa-inr"></i>
                                                                    {/* {flight?.fareDetails?.totalFare} *
                                                                    {flight?.fares?.[0].totalFare}
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            );
                                        })()}
                                    </div>
                                )}
                            </div>

                            {approvalDetails && approvalDetails.airBookingResponse[0] && approvalDetails.airBookingResponse[0].customerInfo && approvalDetails.airBookingResponse[0].customerInfo.passengerDetails.length > 0 && (
                                <>
                                    <div className='row'>
                                        <div className='col-md-12'>
                                            <h4 className='headings'>Passenger Details</h4>
                                        </div>
                                        {approvalDetails && approvalDetails.airBookingResponse[0] && approvalDetails.airBookingResponse[0].customerInfo && approvalDetails.airBookingResponse[0].customerInfo.passengerDetails.map((item, index) => (
                                            <React.Fragment key={index}>
                                                <div className='col-md-12'>
                                                    <div class="d-flex mb-3">
                                                        <div class="labl">Passenger Name </div>
                                                        <div class="labl_detls">{item?.title} {item?.firstName} {item?.lastName}</div>
                                                    </div>
                                                </div>
                                            </React.Fragment>
                                        ))}
                                    </div>
                                </>
                            )}
                            <div className='row'>
                                <div className='col-md-12'>
                                    <h4 className='headings'>Approvals</h4>
                                </div>
                                <div className='col-md-6'>
                                    <div class="d-flex mb-3">
                                        <div class="labl">Approval Level </div>
                                        <div class="labl_detls text-info">Level 1</div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div class="d-flex mb-3">
                                        <div class="labl">Approvar Name </div>
                                        <div class="labl_detls">{approvalDetails.requestedApprovals[0].level1ApproverName} ({approvalDetails.requestedApprovals[0].level1ApproverEmail})</div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div class="d-flex mb-3">
                                        <div class="labl">Requested By </div>
                                        <div class="labl_detls">{approvalDetails.requestedApprovals[0].travellerName} ({approvalDetails.requestedApprovals[0].userId})</div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div class="d-flex mb-3">
                                        <div class="labl">User Remark</div>
                                        <div class="labl_detls">{approvalDetails.approvalRequestRemark}</div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div class="d-flex mb-3">
                                        <div class="labl">Created On</div>
                                        <div class="labl_detls">
                                            {(() => {
                                                const dateStr = approvalDetails?.requestedApprovals?.[0]?.createdOn;
                                                if (!dateStr) return "";

                                                const [datePart, timePart] = dateStr.split(" ");
                                                if (!datePart || !timePart) return "";

                                                const [day, month, year] = datePart.split("-");
                                                const [hour, minute, second] = timePart.split(":");

                                                const dateObj = new Date(
                                                    Number(year),
                                                    Number(month) - 1,
                                                    Number(day),
                                                    Number(hour),
                                                    Number(minute),
                                                    Number(second)
                                                );

                                                if (isNaN(dateObj.getTime())) return "";

                                                return dateObj
                                                    .toLocaleString("en-GB", {
                                                        day: "2-digit",
                                                        month: "short",
                                                        year: "numeric",
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                        hour12: true
                                                    })
                                                    .replace(",", "");
                                            })()}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div class="d-flex mb-3">
                                        <div class="labl">Status </div>
                                        <div class="labl_detls text-danger">{approvalDetails.requestedApprovals[0].level1ApprovalStatus} </div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div class="d-flex mb-3">
                                        <div class="labl">Approvar Action On</div>
                                        <div class="labl_detls">
                                            {(() => {
                                                const dateStr = approvalDetails?.requestedApprovals?.[0]?.level1ApprovedOn;
                                                if (!dateStr) return "";

                                                const [datePart, timePart] = dateStr.split(" ");
                                                if (!datePart || !timePart) return "";

                                                const [day, month, year] = datePart.split("-");
                                                const [hour, minute, second] = timePart.split(":");

                                                const dateObj = new Date(
                                                    Number(year),
                                                    Number(month) - 1,
                                                    Number(day),
                                                    Number(hour),
                                                    Number(minute),
                                                    Number(second)
                                                );

                                                if (isNaN(dateObj.getTime())) return "";

                                                return dateObj
                                                    .toLocaleString("en-GB", {
                                                        day: "2-digit",
                                                        month: "short",
                                                        year: "numeric",
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                        hour12: true
                                                    })
                                                    .replace(",", "");
                                            })()}
                                        </div>
                                    </div>
                                </div>
                                {approvalDetails.requestedApprovals[0].level1ApprovalStatus === "Rejected" && (
                                    <div className='col-md-12'>
                                        <div class="d-flex mb-3">
                                            <div class="labl">Remark </div>
                                            <div class="labl_detls text-danger">{approvalDetails.requestedApprovals[0].remark} </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className='row'>
                                {approvalDetails?.requestedApprovals?.[0]?.level1ApprovalStatus === "Requested" && (
                                    <div className='col-md-12 text-end mt-10 mb-3'>
                                        {/* <button className='btn btn-primary m-1'>Approved Request</button> *
                                        <button
                                            className="btn btn-primary m-1"
                                            onClick={() =>
                                                SubmitAcceptApprovalRequest(approvalDetails?.requestedApprovals?.[0])
                                            }
                                        >
                                            Approve
                                        </button>
                                        <button className='btn btn-primary m-1' data-bs-toggle="modal" data-bs-target="#myModal" onClick={() => setSelectedItem(approvalDetails?.requestedApprovals?.[0])}>Reject</button>
                                    </div>
                                )}
                            </div>
                        </div>


                    </section>

                    <div class="modal fade" id="myModal">
                        <div class="modal-dialog modal-lg">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h4 class="modal-title">Cancel Request</h4>
                                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                                </div>

                                <div class="modal-body">
                                    <div className='col-md-12'>
                                        <label>Why Cancel ?</label>
                                        <textarea className='form-controls' placeholder='Write Reason..' cols={80} rows={4}
                                            value={remark}
                                            onChange={(e) => setRemark(e.target.value)}
                                        ></textarea>
                                    </div>
                                    <div className='col-md-12 text-end'>
                                        <button
                                            className="btn btn-danger"
                                            onClick={() =>
                                                SubmitRejectApprovalRequest(selectedItem)
                                            }
                                        >
                                            Submit Request
                                        </button>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </>
            ) : (
                !loading && approvalDetails && (
                    <>
                        <div class="row mamage_depo">
                            <div class="col-lg-12">
                                <h6 className='ruler'>Flight Approval Details</h6>
                            </div>
                            <div class="col-lg-12">
                                <p className=''>No Flight Approval Details Found !!</p>
                            </div>
                        </div>
                    </>
                )
            )} */}

      {(() => {
        if (approvalDetails?.productType === "Hotel") {
          return <HotelApprovalDetail approvalDetails={approvalDetails} />;
        } else {
          return <div>No data</div>;
        }
      })()}
    </>
  );
};

export default ApprovalDetail;
